import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

const ContactInfoForm = ({ formState, onFormChange }) => {
  const { name, phone, email } = formState;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
      <div>
        <Label htmlFor="name" className="text-base sm:text-lg">Full Name</Label>
        <Input id="name" name="name" placeholder="John Doe" className="mt-2 h-10 sm:h-12 text-sm sm:text-lg" value={name} onChange={(e) => onFormChange('name', e.target.value)} onClear={() => onFormChange('name', '')} required autoComplete="name" />
      </div>
      <div>
        <Label htmlFor="phone" className="text-base sm:text-lg">Phone Number</Label>
        <Input id="phone" name="phone" type="tel" placeholder="(123) 456-7890" className="mt-2 h-10 sm:h-12 text-sm sm:text-lg" value={phone} onChange={(e) => onFormChange('phone', e.target.value)} onClear={() => onFormChange('phone', '')} required autoComplete="tel" />
      </div>
      <div className="md:col-span-2">
        <Label htmlFor="email" className="text-base sm:text-lg">Email Address</Label>
        <Input id="email" name="email" type="email" placeholder="john.doe@example.com" className="mt-2 h-10 sm:h-12 text-sm sm:text-lg" value={email} onChange={(e) => onFormChange('email', e.target.value)} onClear={() => onFormChange('email', '')} required autoComplete="email" />
      </div>
    </div>
  );
};

export default ContactInfoForm;